<template>
    <Head title="Login" />
    <div class="fixed inset-0 flex light login-page overflow-hidden">
        <div class="absolute top-0 left-0 w-full z-50">
            <flash-messages />
        </div>

        <!-- LEFT: Branding panel (desktop only) -->
        <div class="hidden lg:flex lg:w-1/2 h-full relative items-center justify-center overflow-hidden login-brand">
            <div class="login-blob login-blob-1"></div>
            <div class="login-blob login-blob-2"></div>
            <div class="login-blob login-blob-3"></div>

            <div class="relative z-10 text-center px-12">
                <Link :href="route('home')"><logo name="white" class="block mx-auto w-full max-w-xs" height="50" /></Link>
                <h1 class="mt-10 text-3xl font-bold text-white leading-snug">
                    {{ __('Kelola tiket dukungan Anda dengan lebih mudah') }}
                </h1>
            </div>
        </div>

        <!-- RIGHT: Login form -->
        <div class="w-full lg:w-1/2 h-full overflow-y-auto bg-white dark:bg-slate-900">
            <div class="min-h-full flex items-center justify-center p-6 sm:p-8">
                <div class="w-full max-w-md">
                    <!-- Mobile logo -->
                    <Link :href="route('home')" class="lg:hidden block mb-10">
                        <logo class="block mx-auto w-full max-w-[150px]" height="50" />
                    </Link>

                    <form class="login-card" @submit.prevent="login">
                        <h2 class="text-2xl font-bold text-slate-800 dark:text-white">{{ __('Selamat Datang Kembali') }}</h2>
                        <p class="mt-2 text-sm text-slate-500 dark:text-slate-400">{{ __('Login to Helpdesk') }}</p>

                        <text-input v-model="form.email" :error="form.errors.email" class="mt-8" label="Email" type="email" autofocus autocapitalize="off" />
                        <text-input v-model="form.password" :error="form.errors.password" class="mt-5" label="Password" type="password" />

                        <div class="mt-5 flex items-center justify-between">
                            <label class="select-none flex items-center gap-2 cursor-pointer" for="remember">
                                <input id="remember" v-model="form.remember" class="rounded" type="checkbox" />
                                <span class="text-sm text-slate-600 dark:text-slate-300">{{ __('Remember Me') }}</span>
                            </label>
                            <Link class="text-sm font-medium login-link" :href="route('password.reset')">{{ __('Forgot your password?') }}</Link>
                        </div>

                        <loading-button :loading="form.processing" class="login-submit w-full items-center justify-center mt-8" type="submit">{{ __('Login') }}</loading-button>

                        <div v-if="is_demo" class="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
                            <h2 class="text-sm font-bold mb-3 text-center text-slate-600 dark:text-slate-300">{{ __('Login As:') }}</h2>
                            <div class="flex flex-col sm:flex-row gap-3 justify-center">
                                <button class="btn-indigo" @click="autofillLogin($event, 'admin')">Admin</button>
                                <button class="btn-indigo" @click="autofillLogin($event,'manager')">Manager</button>
                                <button class="btn-indigo" @click="autofillLogin($event,'customer')">Customer</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Head, Link } from '@inertiajs/vue3'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  metaInfo: { title: 'Login' },
  components: {
      FlashMessages,
    LoadingButton,
    Logo,
    TextInput,
      Head,
      Link,
  },
    props: {
        is_demo: Number
    },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    }
  },
  methods: {
      login() {
          this.form.post(this.route('login.store'))
      },
      autofillLogin(e, role){
          e.preventDefault()
          const roleEmails = { 'admin': 'john.due.helo@mail.com', 'manager': 'robert.slaughter@mail.com', 'customer' : 'mmarks@example.com'}
          this.form.email = roleEmails[role]
          this.form.password = 'secret'
          this.login();
      }
  }
}
</script>

<style scoped>
.login-brand {
    background: linear-gradient(135deg, #0f3d3a 0%, #1e1b4b 60%, #16142e 100%);
}

.login-blob {
    position: absolute;
    border-radius: 9999px;
    filter: blur(90px);
    opacity: 0.35;
}

.login-blob-1 {
    width: 22rem;
    height: 22rem;
    background: #0f766e;
    top: -6rem;
    left: -6rem;
}

.login-blob-2 {
    width: 26rem;
    height: 26rem;
    background: #4338ca;
    bottom: -8rem;
    right: -8rem;
}

.login-blob-3 {
    width: 16rem;
    height: 16rem;
    background: #4f46e5;
    bottom: 4rem;
    left: 6rem;
}

.login-card {
    width: 100%;
}

.login-submit {
    background: linear-gradient(135deg, #0f766e 0%, #4f46e5 100%);
    border-radius: 0.75rem;
    padding: 0.75rem 1.25rem;
    font-weight: 700;
    color: #fff;
    box-shadow: 0 6px 20px rgba(79, 70, 229, 0.3);
    transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}

.login-submit:hover,
.login-submit:focus {
    filter: brightness(1.08);
    box-shadow: 0 8px 24px rgba(79, 70, 229, 0.4);
    transform: translateY(-1px);
}

.login-link {
    color: #4f46e5;
}

.login-link:hover {
    color: #4338ca;
}
</style>
